var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ru:tab-title",class:[_vm.isSelectedClass, `--${_vm.variant}`],on:{"click":_vm.selectTab}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.subtitle)?_c('span',{staticClass:"ru:tab-title__subtitle"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }